import { get } from 'lodash';
import { getAppSettingsValue, getAppSettings } from '../../app/selectors/app-settings-selectors';
import {
  IS_VIEW_COUNT_ENABLED_PATH,
  LIST_MASONRY_NUMBER_OF_POSTS_PATH,
  LIST_NUMBER_OF_POSTS_PATH,
  LIST_NUMBER_OF_ROWS_PATH,
  LIST_LAYOUT_ID_PATH,
  POST_BORDER_WIDTH_PATH,
  WIDGET_CATEGORY_ID_PATH,
  WIDGET_IS_FEATURED_POST_PATH,
} from '../constants/wix-params';
import { LAYOUT_ID_DEFAULT } from '../constants/layouts';

export const getIsViewCountEnabled = (state) =>
  getAppSettingsValue({ state, key: IS_VIEW_COUNT_ENABLED_PATH, fallback: true });

export const getListLayoutId = (state) =>
  getAppSettingsValue({ state, key: LIST_LAYOUT_ID_PATH, fallback: LAYOUT_ID_DEFAULT });

export const getListNumberOfRows = (state, fallback = 2) =>
  getAppSettingsValue({ state, key: LIST_NUMBER_OF_ROWS_PATH, fallback });

export const getListNumberOfPosts = (state, fallback = 2) =>
  getAppSettingsValue({ state, key: LIST_NUMBER_OF_POSTS_PATH, fallback });

export const getListMasonryNumberOfPosts = (state) =>
  getAppSettingsValue({ state, key: LIST_MASONRY_NUMBER_OF_POSTS_PATH, fallback: 6 });

export const getPostBorderWidth = (state) => getAppSettingsValue({ state, key: POST_BORDER_WIDTH_PATH, fallback: 1 });

export const getWidgetCategoryId = (state) =>
  getAppSettingsValue({ state, key: WIDGET_CATEGORY_ID_PATH, fallback: null });

export const getWidgetIsFeaturedPost = (state) =>
  getAppSettingsValue({ state, key: WIDGET_IS_FEATURED_POST_PATH, fallback: false });

export const getFontDisplayName = (state, name, defaultValue = null) =>
  get(getAppSettings(state), `style.fonts.${name}.displayName`, defaultValue);
